import { z } from 'zod';
import { name, uuid } from './fields';

/**
 * People — household "For" people (data-model.md §2, D5). NOT necessarily app
 * users ("Baby", "Estelle"). Owned by the user whose household they belong to;
 * referenced by `trip_items.for_person_id`.
 *
 * No REST endpoints are pinned in the Phase 1 api-contract yet (people CRUD
 * arrives with trips, T15/T16), so the DTO names here are the shared shapes both
 * apps import — no inline redefinition.
 */

/** Full person resource (response shape). */
export const Person = z.object({
  id: uuid(),
  householdOwnerId: uuid(),
  name: name(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Person = z.infer<typeof Person>;

/** POST body — server sets `householdOwnerId`, `id`, timestamps. */
export const CreatePersonInput = z.object({
  name: name(),
});
export type CreatePersonInput = z.infer<typeof CreatePersonInput>;

/** PATCH body — partial update. */
export const UpdatePersonInput = z
  .object({
    name: name(),
  })
  .partial();
export type UpdatePersonInput = z.infer<typeof UpdatePersonInput>;
